// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"88":"902a360ea249e24a","149":"ad1ac9d4b0d768e7","161":"c59a0174a8c6a500","888":"831744963a5edc22"}[chunkId] + ".css";
};